import { action } from 'satcheljs';

export default action('LOAD_OUTLOOK_FAVORITES');

export const addToOrderedFavoriteIdList = action(
    'ADD_TO_ORDERED_FAVORITE_ID_LIST',
    (favoriteId: string) => {
        return {
            favoriteId,
        };
    }
);
